import { useTranslation } from "react-i18next";
import { cn } from "@/shared/lib/cn";

/**
 * Brand mark — the 가람이엔지(GARAMe) wordmark used in the sidebar header,
 * login page, and PDF reports. 가람이엔지 = ExpertGAS 관제웹 주관사.
 * The PNG (`public/logo.png`) is the canonical asset; an `eager`
 * load hint prevents the layout shifting on first paint.
 *
 *   <Brand height={20} />               just the mark
 *   <Brand height={22} withTagline />   mark + "산업안전 모니터링" small tag
 */
export function Brand({
  height = 22,
  className,
  withTagline = false,
  tagline,
  alt,
}: {
  height?: number;
  className?: string;
  withTagline?: boolean;
  tagline?: string;
  alt?: string;
}) {
  const { t } = useTranslation();
  // 기본값은 렌더 시점에 현지화 — 호출부가 넘긴 값이 있으면 그대로 쓴다.
  const altText = alt ?? t("common.brand.alt");
  const taglineText = tagline ?? t("common.brand.tagline");
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <img
        src="/logo.png"
        alt={altText}
        height={height}
        /* 로고의 짙은 녹색(상대휘도 0.24)이 다크 배경에서 대비가 모자란다.
           다크에서만 밝기를 올려 읽히게 한다 — global.css 참조. */
        className="egas-brand-img"
        // 원본 비율 ~3.6:1 — height 만 고정해 자연스러운 폭 유지.
        style={{ height, width: "auto" }}
        loading="eager"
        decoding="sync"
      />
      {withTagline && (
        <span className="text-[11px] tracking-[0.04em] text-[var(--fg-subtle)] font-medium uppercase">
          {taglineText}
        </span>
      )}
    </span>
  );
}
